export default __webpack_public_path__ + "static/media/coinbaseWallet.a3a7d7fd.svg";